export type ApiBatchResult<T> =
  | { success: true; data: T }
  | { success: false; error: string };

export async function single<T>(
  promise: Promise<ApiBatchResult<T>[]>,
): Promise<T> {
  const results = await promise;
  const [result] = results;
  if (!result) throw new Error("no result returned");
  if (!result.success) throw new Error(result.error);
  return result.data;
}

export async function allOrThrow<T>(
  promise: Promise<ApiBatchResult<T>[]>,
): Promise<T[]> {
  const results = await promise;
  const errors = results
    .filter((r): r is { success: false; error: string } => !r.success)
    .map((r) => r.error);
  if (errors.length > 0) {
    throw new Error(
      `${errors.length}/${results.length} 筆失敗：${errors.join("；")}`,
    );
  }
  return results.map((r) => (r as { success: true; data: T }).data);
}

export function asSingle<I, O>(
  procedure: (input: I[]) => Promise<ApiBatchResult<O>[]>,
): (input: I) => Promise<O> {
  return (input) => single(procedure([input]));
}

export function partitionBatch<T>(results: ApiBatchResult<T>[]): {
  data: T[];
  errors: string[];
} {
  const data: T[] = [];
  const errors: string[] = [];
  for (const result of results) {
    if (result.success) data.push(result.data);
    else errors.push(result.error);
  }
  return { data, errors };
}
